import React from "react";
import PropTypes from "prop-types";
import { PoolDataProvider as Provider } from "@evertrue/vms-insights";
import Api from "core/base/api";

const fetchGoals = poolId =>
  Api.VOLUNTEERS.GOALS.get({
    urlExtend: `/pool/${poolId}`,
    disableAlerts: true,
  }).catch(() => Promise.reject("not found")); // sileneces 'unhandle promise rejection error'

const fetchSettings = poolId =>
  Api.VOLUNTEERS.POOL_SETTINGS.get({
    urlExtend: `/${poolId}`,
    disableAlerts: true,
  }).catch(() => Promise.reject("not found"));

const PoolDataProvider = props => {
  return (
    <Provider fetchGoals={fetchGoals} fetchSettings={fetchSettings}>
      {props.children}
    </Provider>
  );
};
PoolDataProvider.propTypes = {
  children: PropTypes.any,
};
export default PoolDataProvider;
